module.exports = __webpack_public_path__ + "media/images/solo-50-new@2x-33d0a39eaaf2ec90aa89d2b27e2aff45.webp";